import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function TimelineSection() {
    const data = [
        {
            year: "2016",
            title: "Present: Consistent Growth",
            desc: "Expanded across clients and industries, with a focused team delivering long-term reliability"
        },
        {
            year: "2013–2015",
            title: "Technology Transformation",
            desc: "Transitioned from Java and .NET to Ruby on Rails, building a more modern foundation"
        },
        {
            year: "2010–2013",
            title: "Expanding Capabilities",
            desc: "Grew into a 60+ member team supporting enterprise systems across operations"
        }
    ];

    return (
        <section className='padding-section-large'>
            <Container>
                <Row className='mb-4'>
                    <Col md={8}>
                        <h2 className="heading-style-h2 pb-3">How It <span className="text-gradient-1">Evolved</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A steady progression built through experience, learning, and consistent execution. We didn’t grow overnight. Each phase came with its own learning curve.</h5>
                    </Col>
                </Row>

                <div className="py-5 timeline-section">

                    {/* Line */}
                    <div className="timeline-line"></div>

                    <Row>
                        {data.map((item, index) => (
                            <Col md={4} key={index} className="timeline-item">

                                {/* Dot */}
                                <div className="timeline-dot"></div>

                                <h2 className="heading-style-h2 pb-3"><span className="text-gradient-1">{item.year}</span></h2>
                                <h6>{item.title}</h6>
                                <p>{item.desc}</p>

                            </Col>
                        ))}
                    </Row>

                </div>
            </Container>
        </section>
    );
}